import { render, staticRenderFns } from "./dialogResourceInfo.vue?vue&type=template&id=4af813b6&"
import script from "./dialogResourceInfo.vue?vue&type=script&lang=js&"
export * from "./dialogResourceInfo.vue?vue&type=script&lang=js&"
import style0 from "./dialogResourceInfo.vue?vue&type=style&index=0&id=4af813b6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports